import type { PayexThunkAction } from 'store/configureStore';

import {
  getCountryCode,
  getCurrentCountryCode,
  isCAP,
  isFetching,
  localPaymentsAllowed,
} from 'selectors';

import { geolocation } from 'services/geolocation/geolocation';

import {
  SET_SENDER_COUNTRY_FIELD,
  UPDATE_IP_COUNTRY_CODE_REQUEST,
  UPDATE_IP_COUNTRY_CODE_SUCCESS,
} from '../../constants';

export const fetchIPCountryCode =
  (): PayexThunkAction => async (dispatch, getState) => {
    const state = getState();
    const isFetchingGeolocation = isFetching(state, 'geolocation');

    if (isFetchingGeolocation) {
      return Promise.resolve();
    }

    dispatch({ type: UPDATE_IP_COUNTRY_CODE_REQUEST });

    const payload = await geolocation.fetch();

    return dispatch({
      type: UPDATE_IP_COUNTRY_CODE_SUCCESS,
      payload: { countryCode: payload.countryCode },
    });
  };

export const setSenderCountryFromGeolocation =
  (): PayexThunkAction => (dispatch, getState) => {
    const state = getState();
    const recipientIsCAP = isCAP(state);
    const countryCode = getCountryCode(state);
    const isCountrySet = getCurrentCountryCode(state);
    const areLocalPaymentsAllowed = localPaymentsAllowed(state);

    if (
      !countryCode ||
      recipientIsCAP ||
      isCountrySet ||
      areLocalPaymentsAllowed
    ) {
      return;
    }

    dispatch({ type: SET_SENDER_COUNTRY_FIELD, payload: { countryCode } });
  };
